module.exports = __webpack_public_path__ + "static/media/RainMoon09n10n.55102cae.png";